import React from 'react'
import { Link } from 'react-router-dom'

export default function PaymentSuccess() {
  return (
    <div className="container py-5">
      <div className="row justify-content-center">
        <div className="col-12 col-md-9 col-lg-7 col-xl-6">
          <div className="bcs-account-page p-4 p-sm-5 shadow-sm">
            <div className="text-center mb-4">
              <div className="d-inline-flex align-items-center justify-content-center rounded-circle mb-3"
                   style={{ width: 64, height: 64, background: 'rgba(16, 185, 129, 0.12)' }}>
                <span style={{ fontSize: 28 }}>✓</span>
              </div>

              <div className="brand-dark-purple h4 mb-2">Subscription successful</div>
              <div className="bcs-subtitle mb-0">
                You are now subscribed to Neuro Counselloers and your profile is live on the directory.
              </div>
            </div>

            <div className="bcs-account-card bg-white p-3 p-sm-4 mb-4">
              <div className="d-flex align-items-start gap-3">
                <div className="flex-grow-1">
                  <div className="brand-dark-purple mb-1">What happens next</div>

                  <div className="small" style={{ color: 'rgba(44, 27, 69, 0.75)' }}>
                    <div className="mb-2">
                      <span className="me-2">•</span>
                      Your directory listing is now active
                    </div>
                    <div className="mb-2">
                      <span className="me-2">•</span>
                      You can edit your profile any time from your account area
                    </div>
                    <div className="mb-0">
                      <span className="me-2">•</span>
                      Stripe will email your receipt shortly
                    </div>
                  </div>
                </div>

                <div className="text-end">
                  <span className="badge rounded-pill db-av-row-static-on px-3 py-2">
                    Live
                  </span>
                </div>
              </div>
            </div>

     

            <div className="bcs-divider my-4" />

            <div className="text-center">
              <Link to="/" className="bcs-link text-decoration-none">
                Back to home
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}